import React, { type ReactNode } from 'react';

import classnames from 'clsx';

import CheckIcon from '@mui/icons-material/Check';

interface Props {
  labelText: ReactNode;
  checked: boolean;
  onToggle: () => void;
  wrapperClassName?: string;
  buttonClassName?: string;
}

function Checkbox({ labelText, checked, onToggle, wrapperClassName = '', buttonClassName }: Props) {
  return (
    <div className={classnames('le-checkbox-container', wrapperClassName)}>
      <button
        className={classnames('le-checkbox', buttonClassName)}
        role="checkbox"
        aria-checked={checked}
        onClick={onToggle}
      >
        {checked && <CheckIcon className="tick-icon" fontSize="small" />}
      </button>
      <div className="le-checkbox-label" onClick={onToggle}>
        {labelText}
      </div>
    </div>
  );
}

export default Checkbox;
